<template>
    <div class="justify-center gst-btn-logout-wrapper d-flex">
        <v-btn
            color="primary"
            variant="outlined"
            name="gst-btn-logout"
            class="gst-btn-logout"
            :data-test-id="$testId('button.logout')"
            :class="{
                'gst-btn-logout--minimized': isMinimized,
            }"
            @click="onClickSignOutButtonDo">
            <IconRunningMan />
            <span v-if="!isMinimized">{{ $t('buttons.logout') }}</span>
        </v-btn>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { defineAsyncComponent } from 'vue';

export default {
    name: 'UserLogoutButton',
    i18nOptions: {
        namespaces: '_common',
        keyPrefix: '',
    },
    testIdOptions: {
        keyPrefix: '',
    },
    components: {
        IconRunningMan: defineAsyncComponent(() => import('@/assets/icons/IconRunningMan.vue')),
    },
    props: {
        isMinimized: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        ...mapActions({
            oidcSignOut: 'oidcStore/signOutOidc',
            setLoading: 'appState/setLoading',
        }),
        onClickSignOutButtonDo() {
            this.setLoading(true);
            this.oidcSignOut();
        },
    },
};
</script>
<style lang="scss" scoped>
@import '@scssVariables';

.gst-btn-logout-wrapper {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 0px;
    height: 120px;
    background: white;
    align-items: center;
}

.gst-btn-logout {
    font-weight: font-weight('bold');
    font-size: font-size('2xs');
    text-transform: none;
    min-width: auto !important;

    svg {
        margin-right: theme-spacing(2);
    }

    .gst-svg-icon {
        fill: theme-color('primary');
    }
}

.v-btn.gst-btn-logout--minimized {
    padding: theme-spacing(0) theme-spacing(2);

    svg {
        margin-right: theme-spacing(0);
    }
}
</style>
